import { Button } from '@commenda/kakashi';
import { formatNumberWithUniqueCommaPattern } from '@commenda/utils';

import { SelectionActionBar } from '../../../components/SelectionActionBar';

interface IndirectTaxTransactionsSelectionActionBarProps {
  totalSelected: number;
  isSelectAllActive: boolean;
  selectedCount: number;
  pageTransactionCount: number;
  totalTransactions?: number;
  onSelectAll: () => void;
  onClear: () => void;
  onBulkExport?: () => void;
  onBulkDelete?: () => void;
}

const IndirectTaxTransactionsSelectionActionBar = ({
  totalSelected,
  isSelectAllActive,
  selectedCount,
  pageTransactionCount,
  totalTransactions,
  onSelectAll,
  onClear,
  onBulkExport,
  onBulkDelete,
}: IndirectTaxTransactionsSelectionActionBarProps) => {
  return (
    <SelectionActionBar
      count={totalSelected}
      onClear={onClear}
      itemNoun="transaction"
    >
      {!isSelectAllActive &&
        selectedCount === pageTransactionCount &&
        totalTransactions &&
        totalTransactions > pageTransactionCount && (
          <Button variant="secondary" size="sm" onClick={onSelectAll}>
            Select all {formatNumberWithUniqueCommaPattern(totalTransactions)}{' '}
            transactions
          </Button>
        )}

      {onBulkExport && (
        <Button
          variant="primary"
          size="sm"
          onClick={onBulkExport}
          disabled={totalSelected === 0}
        >
          Export {formatNumberWithUniqueCommaPattern(totalSelected)} transactions
        </Button>
      )}

      {onBulkDelete && (
        <Button
          variant="destructive-secondary"
          size="sm"
          onClick={onBulkDelete}
        >
          Delete
        </Button>
      )}
    </SelectionActionBar>
  );
};

export { IndirectTaxTransactionsSelectionActionBar };
